import React, { FC } from 'react';
import { Card, CardContent, Typography } from '@mui/material';

type PageStatusMetricCardProps = {
  label: string;
  value: string | number;
  helper?: string;
  accentColor: string;
};

export const PageStatusMetricCard: FC<PageStatusMetricCardProps> = ({ label, value, helper, accentColor }) => (
  <Card
    variant='outlined'
    sx={{
      flex: { xs: '1 1 100%', sm: '1 1 170px' },
      minWidth: { xs: '100%', sm: 170 },
      maxWidth: '100%',
      borderTop: `4px solid ${accentColor}`,
      borderRadius: 2,
    }}>
    <CardContent sx={{ p: { xs: 1.5, sm: 2 }, '&:last-child': { pb: { xs: 1.5, sm: 2 } } }}>
      <Typography variant='body2' color='text.secondary'>
        {label}
      </Typography>

      <Typography variant='h5' sx={{ fontWeight: 700, mt: 0.5, fontSize: { xs: 22, sm: 24 } }}>
        {value}
      </Typography>

      {helper && (
        <Typography variant='caption' color='text.secondary'>
          {helper}
        </Typography>
      )}
    </CardContent>
  </Card>
);
